<template>
  <v-tooltip bottom>
    <span>{{ raw }}</span>
    <template v-slot:activator="{ on, attrs }">
    <div class="BlockStat" :class="{ 'BlockStat--dark': dark }">
      <span>{{ label }}</span>
      <p v-bind="attrs" v-on="on">{{ value }}</p>
    </div>
    </template>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BlockStat',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    raw: {
      type: Number,
      required: false
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.BlockStat {
  display: inline-block;
  background: #f2f4f6;
  padding: 12px 25px;
  width: 216px;
  text-align: center;
  border-radius: 3px;
  color: #454c5e;

  &--dark {
    background: #454c5e;
    color: #fff;
  }

  span {
    opacity: 0.53;
    font-size: 14px;
  }

  p {
    font-weight: 900;
    font-size: 36px;
    margin: 0;
    text-transform: uppercase;
  }
}
</style>
